import React from 'react';

import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { RootState } from '@whelk/store';
import { isNative } from '@whelk/const/src/env';
import useOpenMMX from '@whelk/hooks/src/useOpenMMX';
import { HistoryLayerLeftIcon, UserDefaultIcon } from '@whelk/assets/src/mobile/icons';

import Dropdown from '../../../Base/Dropdown';

import './style.scss';
import { privacyPolicyUrl, termsOfServiceUrl } from '@whelk/const';
import { openUrl } from '@whelk/utils';
import {
  MenuAboutIcon,
  MenuContactIcon,
  MenuLogoutIconWeb,
  MenuPrivacyPolicy,
  MenuTermsOfService,
} from '@whelk/assets/src/web/new-icons';
// 登录状态用户卡片
const LoginUserCard = ({
  onClickLogout,
  onClickContentUs,
}: {
  onClickLogout: () => void;
  onClickContentUs: () => void;
}) => {
  const { t } = useTranslation();

  const { openMMX } = useOpenMMX();

  const { webAvatar, userName } = useSelector((state: RootState) => state.user);

  // 点击联系我们
  const onClickContactUsBtn = () => {
    onClickContentUs();
  };

  // 点击退出登录
  const onClickLogoutBtn = () => {
    onClickLogout();
  };

  return isNative ? (
    <div className='text-col_text00 flex flex-row items-center'>
      {webAvatar ? (
        <img src={webAvatar} alt='avatar' className='h-6 w-6 rounded-full' />
      ) : (
        <UserDefaultIcon />
      )}
      <span className='ml-[8px] mr-1 text-[15px] font-[500] leading-[21px]'>{userName}</span>
    </div>
  ) : (
    <Dropdown
      menu={[
        { label: t('about_minimax'), onClick: openMMX, icon: <MenuAboutIcon /> },
        { label: t('title_contact_us'), onClick: onClickContactUsBtn, icon: <MenuContactIcon /> },
        {
          label: t('login_user_agreement'),
          onClick: () => openUrl(termsOfServiceUrl, true, '_blank'),
          icon: <MenuTermsOfService />,
        },
        {
          label: t('login_privacy_policy'),
          onClick: () => openUrl(privacyPolicyUrl, true, '_blank'),
          icon: <MenuPrivacyPolicy />,
        },
        { label: t('settings_logout'), onClick: onClickLogoutBtn, icon: <MenuLogoutIconWeb /> },
      ]}
    >
      <div className='text-col_text00 flex flex-row items-center'>
        {webAvatar ? (
          <img src={webAvatar} alt='avatar' className='h-6 w-6 rounded-full' />
        ) : (
          <UserDefaultIcon />
        )}
        <span className='ml-[8px] mr-1 text-[15px] font-[500] leading-[21px]'>{userName}</span>
        <HistoryLayerLeftIcon />
      </div>
    </Dropdown>
  );
};

// 未登录状态用户卡片
const UnLoginUserCard = ({ onClickLogin }: { onClickLogin: () => void }) => {
  const { t } = useTranslation();

  return (
    <div className='text-col_text00 flex h-6 flex-row items-center' onClick={onClickLogin}>
      <UserDefaultIcon />
      <span className='ml-[8px] mr-1 text-[15px] font-[500] leading-[21px]'>
        {t('button_signin')}
      </span>
      <HistoryLayerLeftIcon />
    </div>
  );
};

const MobileUserInfo = ({
  onClickLogin,
  onClickLogout,
  onClickContentUs,
}: {
  onClickLogin: () => void;
  onClickLogout: () => void;
  onClickContentUs: () => void;
}) => {
  const isLogin = useSelector((state: RootState) => state.user.isLogin);

  return isLogin ? (
    <LoginUserCard onClickLogout={onClickLogout} onClickContentUs={onClickContentUs} />
  ) : (
    <UnLoginUserCard onClickLogin={onClickLogin} />
  );
};

export default MobileUserInfo;
